<template>
  <div
    class="pricing-table-icon"
    :class="{
      'pricing-table-icon--circle': variant === 'circle' && !isBoolean,
    }"
  >
    <span class="pricing-table-icon__title" v-if="title">{{ title }}</span>
    <FancyIconCircle
      class="icon-circle"
      :class="{ 'icon-circle--dull': value === false }"
      size=".85rem"
      v-if="variant === 'circle' && isBoolean"
    >
      <template v-if="value">
        <CheckIcon size="1.25rem" />
        <span class="sr-only">Yes</span>
      </template>
      <template v-else>
        <XIcon size="1.25rem" />
        <span class="sr-only">No</span>
      </template>
    </FancyIconCircle>
    <div v-else-if="isBoolean">
      <template v-if="value">
        <CheckIcon size="1.25rem" />
        <span class="sr-only">Yes</span>
      </template>
      <template v-else>
        <span class="sr-only">No</span>
      </template>
    </div>
    <span v-else>{{ value }}</span>
  </div>
</template>

<script>
import { CheckIcon, XIcon, FancyIconCircle } from '@campsite-bio/component-lib';
import { computed, toRefs } from '@nuxtjs/composition-api';

export default {
  components: {
    CheckIcon,
    XIcon,
    FancyIconCircle,
  },

  props: {
    supported: {
      type: [Boolean, Array],
      required: true,
    },

    index: Number,

    variant: {
      type: String,
      default: 'default',
    },

    title: String,
  },

  setup(props) {
    const { supported, index } = toRefs(props);

    const isBoolean = computed(() => {
      return (
        typeof supported.value === 'boolean' ||
        typeof supported.value[index.value] === 'boolean'
      );
    });
    const isString = computed(() => {
      return (
        !isBoolean.value && typeof supported.value[index.value] === 'string'
      );
    });
    const value = computed(() => {
      return Array.isArray(supported.value)
        ? supported.value[index.value]
        : supported.value;
    });

    return { isBoolean, isString, value };
  },
};
</script>

<style lang="scss" scoped>
.pricing-table-icon {
  font-size: 0.75rem;

  &__title {
    font-size: 0.85rem;
    margin-bottom: 0.25rem;
    display: block;
  }
}

.icon-circle.icon-circle {
  background-color: #fff;
  border: 1px solid var(--g-color-gray-200);
  color: var(--g-color-primary);

  &--dull {
    color: var(--g-color-gray-400);
  }
}
</style>
